import { useContext, useEffect, useRef } from "react";
import { WorkspaceContext } from "src/context/workspace";
import { classNames } from "src/helpers/classNames";
import useDevice from "src/hooks/useDevice";
import useIframeResize from "src/hooks/useIframeResize";
import { baseUrl } from "src/config/host";
import { useSiteSettings } from "src/context/SiteSettingsContext";
import useDomoFilterPersistence from "src/hooks/useDomoFilterPersistence";

export default function DomoEmbedProgrammaticFiltering({ content }) {
  const { details: workspaceDetails, menuType } = useContext(WorkspaceContext);
  const { site } = useSiteSettings();
  const device = useDevice();
  const iframeWrapperRef = useRef(null);

  const isExtension = window.location.protocol === "chrome-extension:";

  const { maxWidth } = useIframeResize({ workspaceDetails, site, content });
  const conditionalMaxWidth = content?.embed_type === "EMBED_APP" ? "100%" : maxWidth;

  const { applySavedFilters, removeSavedFilters } = useDomoFilterPersistence(content);

  useEffect(() => {
    const wrapper = iframeWrapperRef.current;
    const iframe = wrapper?.querySelector("iframe") || document.getElementById("iframe");
    if (!iframe) return;

    const handleLoad = () => {
      window.dispatchEvent(new CustomEvent("domo:iframe-loaded", {}));
    };

    iframe.addEventListener("load", handleLoad);
    return () => iframe.removeEventListener("load", handleLoad);
  }, [content?.iframeHtml]);

  useEffect(() => {
    const wrapper = iframeWrapperRef.current;
    const iframe = wrapper?.querySelector("iframe") || document.getElementById("iframe");
    if (!iframe) return;

    const handleLoad = () => {
      window.dispatchEvent(new CustomEvent("domo:iframe-loaded", {}));

      if (content?.page_id) {
        if (content?.persist_filters) {
          applySavedFilters();
        } else {
          removeSavedFilters();
        }
      }
    };

    iframe.addEventListener("load", handleLoad);
    return () => iframe.removeEventListener("load", handleLoad);
  }, [content?.iframeHtml, applySavedFilters, removeSavedFilters, content.persist_filters, content?.page_id]);

  return (
    <div className={classNames("relative h-full w-full select-none", menuType === "horizontal" || menuType === "vertical" ? "" : "")}>
      {isExtension ? (
        <iframe
          id="iframe"
          title="Domo Embed"
          src={`${baseUrl}/embeded/webview?type=domo&action=${content?.pageUrl}&embedToken=${content?.embedToken}`}
          width="100%"
          height="100%"
          onLoad={() => setTimeout(() => window.dispatchEvent(new CustomEvent("domo:iframe-loaded")), 3000)}
        />
      ) : (
        content?.iframeHtml && (
          <div
            ref={iframeWrapperRef}
            className="mx-auto h-full w-full overflow-auto [&_iframe]:h-full"
            style={{
              maxWidth: device === "desktop" ? conditionalMaxWidth || "100%" : "100%",
            }}
            dangerouslySetInnerHTML={{ __html: content?.iframeHtml }}
          />
        )
      )}
    </div>
  );
}
